import SBPLogoTinkoff from './SBPLogoTinkoff';

export default SBPLogoTinkoff;
